import type { Store } from 'shared/store';
import { selectActiveVisitor } from 'shared/store/shared-selectors';
import { selectActiveUser } from 'shared/store/auth-slice';
import type { AppState } from 'shared/store/reducers';

type LoggingContextKey =
  | 'orgId'
  | 'agentId'
  | 'agentSid'
  | 'visitorSid'
  | 'sbid'
  | 'visitorCustomId';
type LoggingContext = Record<LoggingContextKey, string | number>;
type PartialLoggingContext = Partial<LoggingContext>;

let appState = null as null | AppState;

export const initLogContext = (store: Store) => {
  store.subscribe(() => {
    appState = store.getState();
  });
};

export const getCurrentLoggingContext = () => {
  const context: PartialLoggingContext = {};
  if (appState) {
    const user = selectActiveUser(appState);
    const visitor = selectActiveVisitor(appState);
    if (user) {
      context.agentId = user.id;
      context.orgId = user.org.id;
    }
    if (appState.realtime.sid) {
      context.agentSid = appState.realtime.sid;
    }
    if (visitor) {
      context.sbid = visitor.sbid;
      context.visitorSid = visitor.sid;
      context.visitorCustomId = visitor.customId;
    }
  }
  return context;
};
